module.exports = __webpack_public_path__ + "img/applet_2x.3c5a4114.svg";